import { UserRole } from "../../enums";
import { IUserModel } from "../hooks/useAuthentication";

export const getCurrentUserRole = (
  currentUser?: IUserModel | null | undefined
): UserRole | undefined => {
  if (!currentUser) {
    return UserRole.User;
  }
  return currentUser && currentUser.role in UserRole
    ? UserRole[currentUser.role as keyof typeof UserRole]
    : undefined;
};
